import "./CheckEligibility.module.css";
import Header from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import HowItWorks from "./sections/HowItWorks";
import PartnerWithEduStrategix from "./sections/PartnerWithEduStrategix";
import ValuesExpertise from "./sections/ValuesExpertise";
import QuestionsAndAnswers from "./sections/QuestionsAndAnswers";
import Footer from "@/reusable_sections/Footer";
import Form from "./sections/Form";
import ThreeColumnFeature from "./sections/ThreeColumnFeature";
import { FormProvider } from "@/integrations/forms/FormProvider";
export default function CheckEligibilityPage() {
  return <div>
      <Header />
      <FormProvider>
        <Form />
        <ThreeColumnFeature />
        <Contact />
        <HowItWorks />
        <PartnerWithEduStrategix />
        <ValuesExpertise />
        <QuestionsAndAnswers />
      </FormProvider>
      <Footer />
    </div>;
}